// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
// import configs from "../../constants";
//
// const api = createApi({
//     baseQuery: fetchBaseQuery({
//         baseUrl: configs.baseUrl,
//         prepareHeaders: (headers) => {
//             const token = sessionStorage.getItem("kctoken")
//             if (token) headers.set("Authorization", `Bearer ${token}`)
//             return headers
//         }
//     }),
//     endpoints: () => ({})
// })
//
// export default api
//


import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react"
import configs from "../../constants";

const rawBaseQuery = fetchBaseQuery({
    baseUrl: 'http://localhost:8000/',
    prepareHeaders: (headers, api ) => {
        console.log(api)
        const token = sessionStorage.getItem("kctoken")
        if (token) {
            headers.set("Authorization", `Bearer ${token}`)
        }
        let env = 'staging'

        if (api.extra !== undefined) {
            if (api.extra?.env?.toLowerCase() === 'production' || api.extra?.env?.toLowerCase() === "prod") {
                env = 'production'
            }
        } else if(window.localStorage.getItem("isProd") === "true") {
            env = 'production'
        }

        headers.set(
            "X-Target-Environment",
            env
        )
        return headers
    }
})

const dynamicBaseQuery = (args, api, extraOptions) => {
    const urlEnd = typeof args === 'string' ? args : args.url
    const adjustedUrl = configs.baseUrl + urlEnd
    const adjustedArgs = typeof args === 'string' ? adjustedUrl : {...args, url: adjustedUrl}

    let env = '';
    if (args.hasOwnProperty('env') && ['prod', 'local', 'staging','production'].indexOf(args.env) !== -1) {
        if(args.env === 'prod' || args.env === 'production') {
            env = 'production'
        } else {
            env = 'staging'
        }
    } else {
        if (window.localStorage.getItem('isProd') === 'true') {
            env = 'production'
        } else {
            env = 'staging'
        }
    }


    const mergedExtraOptions = {
        ...extraOptions,
        env,
        customHeader: typeof args !== "string" ? args.customHeader : undefined,
    }

    api.extra = {env:env}


    return rawBaseQuery(adjustedArgs, api, mergedExtraOptions)
}

const api = createApi({
    baseQuery: dynamicBaseQuery,
    // Only tags listed here take part in providesTags/invalidatesTags.
    tagTypes: [
        "AiDialogs",
        "AiDialog",
        "CmProgress",
        "AiGlossary",
        "AiTemplates",
        "AiKnowledge",
        "TohClashEvents",
        "TohClashProgress",
        "TohClashLeagues",
        "TohClashLeagueTop",
    ],
    endpoints: () => ({})
})

export default api
